var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BorrarModalComponent',{attrs:{"name":'borrar-' + _vm.puerta_id,"title":"¿Seguro que quieres borrar esta puerta?","confirmButton":"¿BORRAR PUERTA?"},on:{"close":() => _vm.close(false),"confirm":() => _vm.borrarPuerta()}})
}
var staticRenderFns = []

export { render, staticRenderFns }